// Wait for the DOM to be fully loaded
document.addEventListener('turbo:load', function () {
  // Select the div with class 'nav-addy'
  var navAddy = document.querySelector('.nav-addy');
  var deleteLink = document.getElementById('delete-event');

  // Add click event listener to it
  navAddy.addEventListener('click', function () {
    // Retrieve the address from the data-address attribute
    var address = this.getAttribute('data-address');

    // Encode the address for URL use
    var encodedAddress = encodeURIComponent(address);

    // Construct the Google Maps URL
    var googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;

    // Open Google Maps in a new tab
    window.open(googleMapsUrl, '_blank');
  });

  if (deleteLink) {
    deleteLink.addEventListener('click', function (e) {
      e.preventDefault(); // Prevent the link from following through immediately
      var confirmed = confirm('Are you sure you want to delete this event?'); // Show confirmation dialog
      if (confirmed) {
        // If confirmed, manually submit a DELETE request
        var form = document.createElement('form');
        form.method = 'POST';
        form.action = this.href; // The href of the delete link

        // Rails requires a CSRF token to process the request
        var csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
        var csrfInput = document.createElement('input');
        csrfInput.setAttribute('type', 'hidden');
        csrfInput.setAttribute('name', 'authenticity_token');
        csrfInput.setAttribute('value', csrfToken);
        form.appendChild(csrfInput);

        // Rails expects a hidden input named '_method' to simulate PUT, PATCH, or DELETE requests
        var methodInput = document.createElement('input');
        methodInput.setAttribute('type', 'hidden');
        methodInput.setAttribute('name', '_method');
        methodInput.setAttribute('value', 'delete');
        form.appendChild(methodInput);

        document.body.appendChild(form);
        form.submit(); // Submit the form, triggering the DELETE request
      }
    });
  }
});
